/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A strong password only protects the account it's used on — if one site is breached and you've reused it, every other account with that password is exposed too. Generate a unique password per site and keep track of them with a password manager rather than reusing even a very strong one.`)
};

const es_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Una contraseña fuerte solo protege la cuenta en la que se usa — si un sitio se ve comprometido y la has reutilizado, todas las otras cuentas con esa contraseña están expuestas también. Genera una contraseña única por sitio y haz un seguimiento de ellas con un gestor de contraseñas en lugar de reutilizar incluso una muy fuerte.`)
};

const de_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Ein starkes Passwort schützt nur das Konto, auf dem es verwendet wird — wenn eine Website gehackt wird und Sie es wiederverwendet haben, ist jedes andere Konto mit diesem Passwort gefährdet. Generieren Sie ein eindeutiges Passwort pro Website und verwalten Sie diese mit einem Passwort-Manager, anstatt auch ein sehr starkes zu wiederverwenden.`)
};

const nl_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Een sterk wachtwoord beschermt alleen de account waarop het wordt gebruikt — als één site is gehackt en je hebt het hergebruikt, is elke ander account met dat wachtwoord ook blootgesteld. Genereer een uniek wachtwoord per site en houd ze bij met een wachtwoordmanager in plaats van zelfs een zeer sterk account hergebruikt.`)
};

const fr_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Un mot de passe fort ne protège que le compte sur lequel il est utilisé — si un site est compromis et que vous l'avez réutilisé, tous les autres comptes avec ce mot de passe sont également exposés. Générez un mot de passe unique par site et gardez-les à jour avec un gestionnaire de mots de passe plutôt que de réutiliser un mot de passe très fort.`)
};

const it_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Una password forte protegge solo l'account su cui viene utilizzata — se un sito è stato violato e l'hai riusata, ogni altro account con quella password è esposto. Genera una password unica per sito e tieni traccia di esse con un password manager piuttosto che riusare anche una password molto forte.`)
};

const pt_br2_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma senha forte protege apenas a conta em que é usada — se um site for violado e você a tiver reutilizado, todas as outras contas com essa senha também serão expostas. Gere uma senha única por site e controle-as com um gerenciador de senhas em vez de reutilizar, mesmo que uma muito forte.`)
};

const pt_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma senha forte apenas protege a conta em que é utilizada — se um site for comprometido e a tiver reutilizado, todas as outras contas com essa senha também ficam expostas. Gere uma senha única por site e rastreie-as com um gestor de senhas em vez de reutilizar mesmo uma muito forte.`)
};

const ja_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。強いパスワードは、それが使用されるアカウントのみを保護します。1つのサイトが侵害された場合、そのパスワードを再利用していれば、そのパスワードを使用している他のすべてのアカウントも公開されます。各サイトについてユニークなパスワードを生成し、パスワードマネージャーでそれを追跡してください。非常に強力なパスワードであっても、それを再利用しないでください。`)
};

const zh_pw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不应该。强密码只能保护使用它的那个账户——如果其中一个网站遭到入侵，而你重复使用了这个密码，那么所有使用同一密码的其他账户也会随之暴露。应为每个网站生成一个独立密码，并用密码管理器进行管理，而不是重复使用即便是非常强的密码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq4_a", locale)
	if (locale === "en") return en_pw_faq4_a(inputs)
	if (locale === "es") return es_pw_faq4_a(inputs)
	if (locale === "de") return de_pw_faq4_a(inputs)
	if (locale === "nl") return nl_pw_faq4_a(inputs)
	if (locale === "fr") return fr_pw_faq4_a(inputs)
	if (locale === "it") return it_pw_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq4_a(inputs)
	if (locale === "pt") return pt_pw_faq4_a(inputs)
	if (locale === "ja") return ja_pw_faq4_a(inputs)
	return zh_pw_faq4_a(inputs)
};